// extracted by mini-css-extract-plugin
module.exports = {"polaroidListContainer":"PolaroidList_polaroidListContainer__MZpj4","leftToRight":"PolaroidList_leftToRight__caog1"};